import React from 'react';

import ENUMS from '../../enums/index';
import { formatter, enumHelper } from '../../utils';

import ShowForPermission from '../../components/ShowForPermission';

function TableRow(props) {
  const {
    id,
    ix,
    pageNumber,
    pageSize,
    title,
    value,
    currency,
    isPercent,
    showOnFactor,
    isActive,
    createdFullName,
    createdAt
  } = props;

  const toggleStatus = e => {
    e.preventDefault();

    props.toggleStatus(id, isActive);
  };

  const displayDeleteModal = e => {
    e.preventDefault();

    props.displayDeleteModal(id);
  };

  const getIconCssClass = val => {
    return val ? 'fal fa-check-square text-success' : 'fal fa-times-square text-danger';
  };

  const formatValue = () => {
    if (isPercent) {
      return `${value} %`;
    }

    const amount = formatter.numberWithCommas(value);
    const postfix = enumHelper.convertEnumValueToTitle(ENUMS.MONEY_UNITS.list, currency);

    return `${amount} ${postfix}`;
  };

  return (
    <tr>
      <td className="text-center">{(pageNumber - 1) * pageSize + ix + 1}</td>
      <td className="text-center">
        <strong>{title}</strong>
      </td>
      <td className="text-center">{formatValue()}</td>
      <td className="text-center">
        <i className={getIconCssClass(showOnFactor)} />
      </td>
      <td className="text-center">
        <i className={getIconCssClass(isActive)} />
      </td>
      <td className="text-center">{createdFullName}</td>
      <td className="text-center">{createdAt}</td>
      <ShowForPermission permission={ENUMS.PERMISSIONS.values.ACTIVE_INACTIVE_CAFE_FACTOR_ADDITION}>
        <td>
          <button
            className={`${isActive ? 'btn-danger' : 'btn-success'} btn btn-sm`}
            onClick={toggleStatus}
          >
            {locales(isActive ? 'tables.deactivate' : 'tables.activate')}
          </button>
        </td>
      </ShowForPermission>
      <ShowForPermission permission={ENUMS.PERMISSIONS.values.DELETE_CAFE_FACTOR_ADDITION}>
        <td title={locales('labels.delete.addition.item')}>
          <a href="#" onClick={displayDeleteModal}>
            <i className="text-center fal fa-trash text-danger pointer" />
          </a>
        </td>
      </ShowForPermission>
    </tr>
  );
}

export default TableRow;
